"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = __importStar(require("react"));

var remotion_1 = require("remotion");

var calculate_scale_1 = require("./calculate-scale");

var error_boundary_1 = require("./error-boundary");

var player_css_classname_1 = require("./player-css-classname");

var PlayerControls_1 = require("./PlayerControls");

var use_hover_state_1 = require("./use-hover-state");

var use_playback_1 = require("./use-playback");

var use_player_1 = require("./use-player");

var is_node_1 = require("./utils/is-node");

var use_click_prevention_on_double_click_1 = require("./utils/use-click-prevention-on-double-click");

var use_element_size_1 = require("./utils/use-element-size");

var reactVersion = react_1.default.version.split('.')[0];

if (reactVersion === '0') {
  throw new Error("Version ".concat(reactVersion, " of \"react\" is not supported by Remotion"));
}

var doesReactVersionSupportSuspense = parseInt(reactVersion, 10) >= 18;

var PlayerUI = function PlayerUI(_ref, ref) {
  var controls = _ref.controls,
      style = _ref.style,
      loop = _ref.loop,
      autoPlay = _ref.autoPlay,
      allowFullscreen = _ref.allowFullscreen,
      inputProps = _ref.inputProps,
      clickToPlay = _ref.clickToPlay,
      showVolumeControls = _ref.showVolumeControls,
      doubleClickToFullscreen = _ref.doubleClickToFullscreen,
      spaceKeyToPlayOrPause = _ref.spaceKeyToPlayOrPause,
      errorFallback = _ref.errorFallback,
      playbackRate = _ref.playbackRate,
      renderLoading = _ref.renderLoading,
      renderPoster = _ref.renderPoster,
      className = _ref.className,
      moveToBeginningWhenEnded = _ref.moveToBeginningWhenEnded,
      showPosterWhenUnplayed = _ref.showPosterWhenUnplayed,
      showPosterWhenEnded = _ref.showPosterWhenEnded,
      showPosterWhenPaused = _ref.showPosterWhenPaused,
      inFrame = _ref.inFrame,
      outFrame = _ref.outFrame,
      initiallyShowControls = _ref.initiallyShowControls,
      renderFullscreenButton = _ref.renderFullscreen,
      renderPlayPauseButton = _ref.renderPlayPauseButton;

  var _a, _b, _c, _d, _e;

  var config = remotion_1.Internals.useUnsafeVideoConfig();
  var video = remotion_1.Internals.useVideo();
  var container = (0, react_1.useRef)(null);
  var hovered = (0, use_hover_state_1.useHoverState)(container);
  var canvasSize = (0, use_element_size_1.useElementSize)(container, {
    triggerOnWindowResize: false,
    shouldApplyCssTransforms: false
  });

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      hasPausedToResume = _ref3[0],
      setHasPausedToResume = _ref3[1];

  var _ref4 = (0, react_1.useState)(autoPlay),
      _ref5 = _slicedToArray(_ref4, 2),
      shouldAutoplay = _ref5[0],
      setShouldAutoPlay = _ref5[1];

  var _ref6 = (0, react_1.useState)(function () {
    return false;
  }),
      _ref7 = _slicedToArray(_ref6, 2),
      _isFullscreen = _ref7[0],
      setIsFullscreen = _ref7[1];

  var _ref8 = (0, react_1.useState)(false),
      _ref9 = _slicedToArray(_ref8, 2),
      seeking = _ref9[0],
      setSeeking = _ref9[1];

  (0, use_playback_1.usePlayback)({
    loop: loop,
    playbackRate: playbackRate,
    moveToBeginningWhenEnded: moveToBeginningWhenEnded,
    inFrame: inFrame,
    outFrame: outFrame
  });
  var player = (0, use_player_1.usePlayer)();
  (0, react_1.useEffect)(function () {
    if (hasPausedToResume && !player.playing) {
      setHasPausedToResume(false);
      player.play();
    }
  }, [hasPausedToResume, player]);
  (0, react_1.useEffect)(function () {
    var current = container.current;

    if (!current) {
      return;
    }

    var onFullscreenChange = function onFullscreenChange() {
      setIsFullscreen(document.fullscreenElement === current || document.webkitFullscreenElement === current);
    };

    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', onFullscreenChange);
    return function () {
      document.removeEventListener('fullscreenchange', onFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', onFullscreenChange);
    };
  }, []);
  var toggle = (0, react_1.useCallback)(function (e) {
    if (player.isPlaying()) {
      player.pause();
    } else {
      player.play(e);
    }
  }, [player]);
  var requestFullscreen = (0, react_1.useCallback)(function () {
    if (!allowFullscreen) {
      throw new Error('allowFullscreen is false');
    }

    var supportsFullScreen = document.fullscreenEnabled || document.webkitFullscreenEnabled;

    if (!supportsFullScreen) {
      throw new Error('Browser doesnt support fullscreen');
    }

    if (!container.current) {
      throw new Error('No player ref found');
    }

    if (container.current.webkitRequestFullScreen) {
      container.current.webkitRequestFullScreen();
    } else {
      container.current.requestFullscreen();
    }
  }, [allowFullscreen]);
  var exitFullscreen = (0, react_1.useCallback)(function () {
    if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else {
      document.exitFullscreen();
    }
  }, []);
  (0, react_1.useEffect)(function () {
    var current = container.current;

    if (!current) {
      return;
    }

    var fullscreenChange = function fullscreenChange() {
      var _a;

      var element = (_a = document.webkitFullscreenElement) !== null && _a !== void 0 ? _a : document.fullscreenElement;

      if (element && element === container.current) {
        player.emitter.dispatchFullscreenChangeUpdate({
          isFullscreen: true
        });
      } else {
        player.emitter.dispatchFullscreenChangeUpdate({
          isFullscreen: false
        });
      }
    };

    current.addEventListener('webkitfullscreenchange', fullscreenChange);
    current.addEventListener('fullscreenchange', fullscreenChange);
    return function () {
      current.removeEventListener('webkitfullscreenchange', fullscreenChange);
      current.removeEventListener('fullscreenchange', fullscreenChange);
    };
  }, [player.emitter]);
  var durationInFrames = (_a = config === null || config === void 0 ? void 0 : config.durationInFrames) !== null && _a !== void 0 ? _a : 1;
  var layout = (0, react_1.useMemo)(function () {
    if (!config || !canvasSize) {
      return null;
    }

    return (0, calculate_scale_1.calculateCanvasTransformation)({
      canvasSize: canvasSize,
      compositionHeight: config.height,
      compositionWidth: config.width,
      previewSize: 'auto'
    });
  }, [canvasSize, config]);
  var scale = (_b = layout === null || layout === void 0 ? void 0 : layout.scale) !== null && _b !== void 0 ? _b : 1;

  var _ref10 = (0, react_1.useContext)(remotion_1.Internals.SetMediaVolumeContext),
      setMediaVolume = _ref10.setMediaVolume,
      setMediaMuted = _ref10.setMediaMuted;

  var _ref11 = (0, react_1.useContext)(remotion_1.Internals.MediaVolumeContext),
      mediaMuted = _ref11.mediaMuted,
      mediaVolume = _ref11.mediaVolume;

  (0, react_1.useImperativeHandle)(ref, function () {
    var methods = {
      play: player.play,
      pause: player.pause,
      toggle: toggle,
      getContainerNode: function getContainerNode() {
        return container.current;
      },
      getCurrentFrame: player.getCurrentFrame,
      isPlaying: function isPlaying() {
        return player.playing;
      },
      seekTo: function seekTo(f) {
        var lastFrame = durationInFrames - 1;
        var frameToSeekTo = Math.max(0, Math.min(lastFrame, f));

        if (player.isPlaying()) {
          var pauseToResume = frameToSeekTo !== lastFrame || loop;
          setHasPausedToResume(pauseToResume);
          player.pause();
        }

        if (frameToSeekTo === lastFrame && !loop) {
          player.emitter.dispatchEnded();
        }

        player.seek(frameToSeekTo);
      },
      isFullscreen: function isFullscreen() {
        return _isFullscreen;
      },
      requestFullscreen: requestFullscreen,
      exitFullscreen: exitFullscreen,
      getVolume: function getVolume() {
        if (mediaMuted) {
          return 0;
        }

        return mediaVolume;
      },
      setVolume: function setVolume(vol) {
        if (typeof vol !== 'number') {
          throw new TypeError("setVolume() takes a number, got value of type ".concat(typeof vol));
        }

        if (isNaN(vol)) {
          throw new TypeError("setVolume() got a number that is NaN. Volume must be between 0 and 1.");
        }

        if (vol < 0 || vol > 1) {
          throw new TypeError("setVolume() got a number that is out of range. Must be between 0 and 1, got ".concat(typeof vol));
        }

        setMediaVolume(vol);
      },
      isMuted: function isMuted() {
        return mediaMuted || mediaVolume === 0;
      },
      mute: function mute() {
        setMediaMuted(true);
      },
      unmute: function unmute() {
        setMediaMuted(false);
      },
      getScale: function getScale() {
        return scale;
      }
    };
    return Object.assign(player.emitter, methods);
  }, [durationInFrames, exitFullscreen, _isFullscreen, loop, mediaMuted, mediaVolume, player, requestFullscreen, setMediaMuted, setMediaVolume, toggle, scale]);
  var VideoComponent = video ? video.component : null;
  var outerStyle = (0, react_1.useMemo)(function () {
    return (0, calculate_scale_1.calculateOuterStyle)({
      canvasSize: canvasSize,
      config: config,
      style: style
    });
  }, [canvasSize, config, style]);
  var outer = (0, react_1.useMemo)(function () {
    return (0, calculate_scale_1.calculateOuter)({
      config: config,
      layout: layout,
      scale: scale
    });
  }, [config, layout, scale]);
  var containerStyle = (0, react_1.useMemo)(function () {
    return (0, calculate_scale_1.calculateContainerStyle)({
      canvasSize: canvasSize,
      config: config,
      layout: layout,
      scale: scale
    });
  }, [canvasSize, config, layout, scale]);
  var onError = (0, react_1.useCallback)(function (error) {
    player.pause(); // Pay attention to `this context`

    player.emitter.dispatchError(error);
  }, [player]);
  var onFullscreenButtonClick = (0, react_1.useCallback)(function (e) {
    e.stopPropagation();
    requestFullscreen();
  }, [requestFullscreen]);
  var onExitFullscreenButtonClick = (0, react_1.useCallback)(function (e) {
    e.stopPropagation();
    exitFullscreen();
  }, [exitFullscreen]);
  var onSingleClick = (0, react_1.useCallback)(function (e) {
    toggle(e);
  }, [toggle]);
  var onSeekStart = (0, react_1.useCallback)(function () {
    setSeeking(true);
  }, []);
  var onSeekEnd = (0, react_1.useCallback)(function () {
    setSeeking(false);
  }, []);
  var onDoubleClick = (0, react_1.useCallback)(function () {
    if (_isFullscreen) {
      exitFullscreen();
    } else {
      requestFullscreen();
    }
  }, [exitFullscreen, _isFullscreen, requestFullscreen]);

  var _ref12 = (0, use_click_prevention_on_double_click_1.useClickPreventionOnDoubleClick)(onSingleClick, onDoubleClick, doubleClickToFullscreen),
      _ref13 = _slicedToArray(_ref12, 2),
      handleClick = _ref13[0],
      handleDoubleClick = _ref13[1];

  (0, react_1.useEffect)(function () {
    if (shouldAutoplay) {
      player.play();
      setShouldAutoPlay(false);
    }
  }, [shouldAutoplay, player]);
  var loadingMarkup = (0, react_1.useMemo)(function () {
    return renderLoading ? renderLoading({
      height: outerStyle.height,
      width: outerStyle.width
    }) : null;
  }, [outerStyle.height, outerStyle.width, renderLoading]);

  if (!config) {
    return null;
  }

  var poster = renderPoster ? renderPoster({
    height: outerStyle.height,
    width: outerStyle.width
  }) : null;

  if (poster === undefined) {
    throw new TypeError('renderPoster() must return a React element, but undefined was returned');
  }

  var shouldShowPoster = poster && [showPosterWhenPaused && !player.isPlaying() && !seeking, showPosterWhenEnded && player.isLastFrame && !player.isPlaying(), showPosterWhenUnplayed && !player.hasPlayed && !player.isPlaying()].some(Boolean);
  var content = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)("div", {
      style: outer,
      onClick: clickToPlay ? handleClick : undefined,
      onDoubleClick: doubleClickToFullscreen ? handleDoubleClick : undefined,
      children: (0, jsx_runtime_1.jsx)("div", {
        style: containerStyle,
        className: player_css_classname_1.PLAYER_CSS_CLASSNAME,
        children: VideoComponent ? (0, jsx_runtime_1.jsx)(error_boundary_1.ErrorBoundary, {
          onError: onError,
          errorFallback: errorFallback,
          children: (0, jsx_runtime_1.jsx)(VideoComponent, _objectSpread(_objectSpread({}, (_c = video === null || video === void 0 ? void 0 : video.defaultProps) !== null && _c !== void 0 ? _c : {}), (_d = inputProps) !== null && _d !== void 0 ? _d : {}))
        }) : null
      })
    }), shouldShowPoster ? (0, jsx_runtime_1.jsx)("div", {
      style: outer,
      onClick: clickToPlay ? handleClick : undefined,
      onDoubleClick: doubleClickToFullscreen ? handleDoubleClick : undefined,
      children: poster
    }) : null, controls ? (0, jsx_runtime_1.jsx)(PlayerControls_1.Controls, {
      fps: config.fps,
      durationInFrames: config.durationInFrames,
      hovered: hovered,
      player: player,
      onFullscreenButtonClick: onFullscreenButtonClick,
      isFullscreen: _isFullscreen,
      allowFullscreen: allowFullscreen,
      showVolumeControls: showVolumeControls,
      onExitFullscreenButtonClick: onExitFullscreenButtonClick,
      spaceKeyToPlayOrPause: spaceKeyToPlayOrPause,
      onSeekEnd: onSeekEnd,
      onSeekStart: onSeekStart,
      inFrame: inFrame,
      outFrame: outFrame,
      initiallyShowControls: initiallyShowControls,
      playerWidth: (_e = canvasSize === null || canvasSize === void 0 ? void 0 : canvasSize.width) !== null && _e !== void 0 ? _e : 0,
      renderFullscreenButton: renderFullscreenButton,
      renderPlayPauseButton: renderPlayPauseButton
    }) : null]
  });

  if (is_node_1.IS_NODE && !doesReactVersionSupportSuspense) {
    return (0, jsx_runtime_1.jsx)("div", {
      ref: container,
      style: outerStyle,
      className: className,
      children: content
    });
  }

  return (0, jsx_runtime_1.jsx)("div", {
    ref: container,
    style: outerStyle,
    className: className,
    children: (0, jsx_runtime_1.jsx)(react_1.Suspense, {
      fallback: loadingMarkup,
      children: content
    })
  });
};

exports.default = (0, react_1.forwardRef)(PlayerUI);